var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHidden)?_c('div',{staticClass:"c-modern-sidebar"},[_c('ModernSidebarCurrency'),_vm._l((_vm.tabs),function(tab,tabPosition){return [(_vm.tabVisibilities[tabPosition])?_c('ModernTabButton',{key:tab.name,attrs:{"tab":tab,"tab-position":tabPosition}}):_vm._e()]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }